import { Outlet } from 'react-router-dom';

export function PlainLayout() {
  return <Outlet />;
}